// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1KIQL","colMin":"styles_colMin__2R1XY","colCheckbox":"styles_colCheckbox__12Crb"};